"use strict";

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _get = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RectSelector = exports.SelectionModificator = void 0;

var Point2D_1 = require("../../Core/Point2D");

var Rect_1 = require("../../Core/Rect");

var RegionData_1 = require("../../Core/RegionData");

var CrossElement_1 = require("../Component/CrossElement");

var RectElement_1 = require("../Component/RectElement");

var Selector_1 = require("./Selector");
/**
 * Enum to specify selection mode.
 */


var SelectionModificator;

(function (SelectionModificator) {
  SelectionModificator[SelectionModificator["RECT"] = 0] = "RECT";
  SelectionModificator[SelectionModificator["SQUARE"] = 1] = "SQUARE";
})(SelectionModificator = exports.SelectionModificator || (exports.SelectionModificator = {}));
/**
 * The selector to define a rect-region.
 */


var RectSelector = /*#__PURE__*/function (_Selector_1$Selector) {
  _inherits(RectSelector, _Selector_1$Selector);

  /**
   * Creates new `RectSelector` object.
   * @param parent - The parent SVG-element.
   * @param paper - The `Snap.Paper` element to draw on.
   * @param boundRect - The bounding box.
   * @param callbacks - The collection of callbacks.
   */
  function RectSelector(parent, paper, boundRect, callbacks) {
    var _this;

    _classCallCheck(this, RectSelector);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RectSelector).call(this, parent, paper, boundRect, callbacks));
    /**
     * Internal flag for selection state.
     */

    _this.capturingState = false;
    /**
     * Pointer Id for capturing
     */

    _this.pointerCaptureId = -1;
    /**
     * Internal flag for selection mode.
     */

    _this.isTwoPoints = false;
    /**
     * Internal flag for selection type.
     */

    _this.selectionModificator = SelectionModificator.RECT;

    _this.buildUIElements();

    _this.hide();

    return _this;
  }
  /**
   * Resizes the selector to specified `width` and `height`.
   * @param width - The new `width`.
   * @param height - The new `height`.
   */


  _createClass(RectSelector, [{
    key: "resize",
    value: function resize(width, height) {
      _get(_getPrototypeOf(RectSelector.prototype), "resize", this).call(this, width, height);

      this.resizeAll([this.selectionBox, this.crossA, this.crossB]);
    }
    /**
     * Hides the selector.
     */

  }, {
    key: "hide",
    value: function hide() {
      _get(_getPrototypeOf(RectSelector.prototype), "hide", this).call(this);

      this.hideAll([this.crossA, this.crossB, this.selectionBox]);

      if (this.pointerCaptureId >= 0) {
        this.parentNode.releasePointerCapture(this.pointerCaptureId);
        this.pointerCaptureId = -1;
      }
    }
    /**
     * Shows the selector.
     */

  }, {
    key: "show",
    value: function show() {
      _get(_getPrototypeOf(RectSelector.prototype), "show", this).call(this);

      this.crossA.show();
    }
    /**
     * Builds selector's UI.
     */

  }, {
    key: "buildUIElements",
    value: function buildUIElements() {
      this.node = this.paper.g();
      this.node.addClass("rectSelector");
      this.crossA = new CrossElement_1.CrossElement(this.paper, this.boundRect);
      this.crossB = new CrossElement_1.CrossElement(this.paper, this.boundRect);
      this.selectionBox = new RectElement_1.RectElement(this.paper, this.boundRect, new Rect_1.Rect(0, 0));
      this.selectionBox.node.addClass("selectionBoxStyle");
      this.node.add(this.crossA.node);
      this.node.add(this.crossB.node);
      this.node.add(this.selectionBox.node);
      var listeners = [{
        event: "pointerenter",
        listener: this.onPointerEnter,
        base: this.parentNode,
        bypass: false
      }, {
        event: "pointerleave",
        listener: this.onPointerLeave,
        base: this.parentNode,
        bypass: false
      }, {
        event: "pointerdown",
        listener: this.onPointerDown,
        base: this.parentNode,
        bypass: false
      }, {
        event: "pointerup",
        listener: this.onPointerUp,
        base: this.parentNode,
        bypass: false
      }, {
        event: "pointermove",
        listener: this.onPointerMove,
        base: this.parentNode,
        bypass: false
      }, {
        event: "keydown",
        listener: this.onKeyDown,
        base: window,
        bypass: false
      }, {
        event: "keyup",
        listener: this.onKeyUp,
        base: window,
        bypass: true
      }];
      this.subscribeToEvents(listeners);
    }
    /**
     * Helper function to move the rect element to specified locations.
     * @param box - The box to move.
     * @param pa - The first corner point.
     * @param pb - The opposite corner point.
     */

  }, {
    key: "moveSelectionBox",
    value: function moveSelectionBox(box, pa, pb) {
      var x = pa.x < pb.x ? pa.x : pb.x;
      var y = pa.y < pb.y ? pa.y : pb.y;
      var w = Math.abs(pa.x - pb.x);
      var h = Math.abs(pa.y - pb.y);
      box.move(new Point2D_1.Point2D(x, y));
      box.resize(w, h);
    }
    /**
     * Listener for the pointer enter event.
     * @param e PointerEvent
     */

  }, {
    key: "onPointerEnter",
    value: function onPointerEnter(e) {
      var _this2 = this;

      window.requestAnimationFrame(function () {
        _this2.crossA.show();
      });
    }
    /**
     * Listener for the pointer leave event.
     * @param e PointerEvent
     */

  }, {
    key: "onPointerLeave",
    value: function onPointerLeave(e) {
      var _this3 = this;

      window.requestAnimationFrame(function () {
        var rect = _this3.parentNode.getClientRects();

        var p = new Point2D_1.Point2D(e.clientX - rect[0].left, e.clientY - rect[0].top);

        if (!_this3.capturingState) {
          _this3.hideAll([_this3.crossA, _this3.crossB, _this3.selectionBox]);
        } else if (_this3.isTwoPoints && _this3.capturingState) {
          _this3.moveCross(_this3.crossB, p);

          _this3.moveSelectionBox(_this3.selectionBox, _this3.crossA, _this3.crossB);
        }
      });
    }
    /**
     * Listener for the pointer down event.
     * @param e PointerEvent
     */

  }, {
    key: "onPointerDown",
    value: function onPointerDown(e) {
      var _this4 = this;

      window.requestAnimationFrame(function () {
        if (!_this4.isTwoPoints) {
          _this4.capturingState = true;
          _this4.pointerCaptureId = e.pointerId;

          _this4.parentNode.setPointerCapture(_this4.pointerCaptureId);

          _this4.moveCross(_this4.crossB, _this4.crossA);

          _this4.moveSelectionBox(_this4.selectionBox, _this4.crossA, _this4.crossB);

          _this4.showAll([_this4.crossA, _this4.crossB, _this4.selectionBox]);

          if (typeof _this4.callbacks.onSelectionBegin === "function") {
            _this4.callbacks.onSelectionBegin();
          }
        }
      });
    }
    /**
     * Listener for the pointer up event.
     * @param e PointerEvent
     */

  }, {
    key: "onPointerUp",
    value: function onPointerUp(e) {
      var _this5 = this;

      window.requestAnimationFrame(function () {
        var rect = _this5.parentNode.getClientRects();

        var p = new Point2D_1.Point2D(e.clientX - rect[0].left, e.clientY - rect[0].top);

        if (!_this5.isTwoPoints) {
          _this5.capturingState = false;

          if (_this5.pointerCaptureId >= 0) {
            _this5.parentNode.releasePointerCapture(_this5.pointerCaptureId);

            _this5.pointerCaptureId = -1;
          }

          _this5.hideAll([_this5.crossB, _this5.selectionBox]);

          if (typeof _this5.callbacks.onSelectionEnd === "function") {
            var x = Math.min(_this5.crossA.x, _this5.crossB.x);
            var y = Math.min(_this5.crossA.y, _this5.crossB.y);
            var w = Math.abs(_this5.crossA.x - _this5.crossB.x);
            var h = Math.abs(_this5.crossA.y - _this5.crossB.y);

            _this5.callbacks.onSelectionEnd(RegionData_1.RegionData.BuildRectRegionData(x, y, w, h));
          }
        } else {
          if (_this5.capturingState) {
            _this5.capturingState = false;

            _this5.hideAll([_this5.crossB, _this5.selectionBox]);

            if (typeof _this5.callbacks.onSelectionEnd === "function") {
              var _x = Math.min(_this5.crossA.x, _this5.crossB.x);

              var _y = Math.min(_this5.crossA.y, _this5.crossB.y);

              var _w = Math.abs(_this5.crossA.x - _this5.crossB.x);

              var _h = Math.abs(_this5.crossA.y - _this5.crossB.y);

              _this5.callbacks.onSelectionEnd(RegionData_1.RegionData.BuildRectRegionData(_x, _y, _w, _h));
            }

            _this5.moveCross(_this5.crossA, p);

            _this5.moveCross(_this5.crossB, p);
          } else {
            _this5.capturingState = true;

            _this5.moveCross(_this5.crossB, p);

            _this5.moveSelectionBox(_this5.selectionBox, _this5.crossA, _this5.crossB);

            _this5.showAll([_this5.crossA, _this5.crossB, _this5.selectionBox]);

            if (typeof _this5.callbacks.onSelectionBegin === "function") {
              _this5.callbacks.onSelectionBegin();
            }
          }
        }
      });
    }
    /**
     * Listener for the pointer move event.
     * @param e PointerEvent
     */

  }, {
    key: "onPointerMove",
    value: function onPointerMove(e) {
      var _this6 = this;

      window.requestAnimationFrame(function () {
        var rect = _this6.parentNode.getClientRects();

        var p = new Point2D_1.Point2D(e.clientX - rect[0].left, e.clientY - rect[0].top);

        if (!_this6.isTwoPoints) {
          if (_this6.capturingState) {
            _this6.moveCross(_this6.crossB, p, _this6.selectionModificator === SelectionModificator.SQUARE, _this6.crossA);

            _this6.moveSelectionBox(_this6.selectionBox, _this6.crossA, _this6.crossB);
          } else {
            _this6.moveCross(_this6.crossA, p);
          }
        } else {
          if (_this6.capturingState) {
            _this6.moveCross(_this6.crossB, p, _this6.selectionModificator === SelectionModificator.SQUARE, _this6.crossA);

            _this6.moveSelectionBox(_this6.selectionBox, _this6.crossA, _this6.crossB);
          } else {
            _this6.moveCross(_this6.crossA, p);

            _this6.moveCross(_this6.crossB, p);
          }
        }
      });
      e.preventDefault();
    }
    /**
     * Listener for the key down event.
     * @param e KeyboardEvent
     */

  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      // Holding shift key enable square drawing mode
      if (e.shiftKey) {
        this.selectionModificator = SelectionModificator.SQUARE;
      }

      if (e.ctrlKey && !this.capturingState) {
        this.isTwoPoints = true;
      }
    }
    /**
     * Listener for the key up event.
     * @param e KeyboardEvent
     */

  }, {
    key: "onKeyUp",
    value: function onKeyUp(e) {
      // Holding shift key enable square drawing mode
      if (!e.shiftKey) {
        this.selectionModificator = SelectionModificator.RECT;
      } // Holding Ctrl key to enable two point selection mode


      if (!e.ctrlKey && this.isTwoPoints) {
        this.isTwoPoints = false;
        this.capturingState = false;
        this.moveCross(this.crossA, this.crossB);
        this.hideAll([this.crossB, this.selectionBox]);
      }
    }
  }]);

  return RectSelector;
}(Selector_1.Selector);

exports.RectSelector = RectSelector;